import { render, staticRenderFns } from "./confirmDeletionCollectionModal.vue?vue&type=template&id=080f8444&"
import script from "./confirmDeletionCollectionModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports